import styles from './styles/Pagination.module.scss';
import React from 'react';
const styleButton = `btn:cleared d:flex ai:center jc:center trs:all:300 ${styles.button}`;
const Button = ({ active, page, onClick }) => {
    return (React.createElement("button", { className: styleButton, ...active && { 'data-active': '' }, onClick: onClick }, page));
};
const Dots = () => (React.createElement("li", { className: `${styleButton} ${styles.dots}` }, "..."));
export const Pagination = ({ totalPages, currentPage, setPageFunction }) => {
    const items = [];
    if (currentPage < 6) {
        for (let i = 1; i < 7 && i <= totalPages; i++) {
            items.push(React.createElement("li", { key: `s${i}` },
                React.createElement(Button, { active: i === currentPage, page: i, onClick: () => { i !== currentPage && setPageFunction(i); } })));
        }
        if (totalPages > 6) {
            if (totalPages - 2 > 6) {
                items.push(React.createElement(Dots, { key: "eDot" }));
            }
            for (let i = Math.max(7, totalPages - 1); i <= totalPages; i++) {
                items.push(React.createElement("li", { key: `e${i}` },
                    React.createElement(Button, { active: false, page: i, onClick: () => { setPageFunction(i); } })));
            }
        }
    }
    else if (currentPage > totalPages - 5) {
        for (let i = 1; i < 3 && i < totalPages - 5; i++) {
            items.push(React.createElement("li", { key: `s${i}` },
                React.createElement(Button, { active: false, page: i, onClick: () => { setPageFunction(i); } })));
        }
        if (totalPages - 6 > 2) {
            items.push(React.createElement(Dots, { key: "sDot" }));
        }
        for (let i = totalPages - 5; i <= totalPages; i++) {
            items.push(React.createElement("li", { key: `e${i}` },
                React.createElement(Button, { active: i === currentPage, page: i, onClick: () => { i !== currentPage && setPageFunction(i); } })));
        }
    }
    else {
        for (let i = 1; i < 3 && i < currentPage; i++) {
            items.push(React.createElement("li", { key: `s${i}` },
                React.createElement(Button, { active: false, page: i, onClick: () => { setPageFunction(i); } })));
        }
        if (currentPage - 1 > 3) {
            items.push(React.createElement(Dots, { key: "sDot" }));
        }
        for (let i = currentPage - 1; i < currentPage + 2; i++) {
            items.push(React.createElement("li", { key: `m${i}` },
                React.createElement(Button, { active: i === currentPage, page: i, onClick: () => { i !== currentPage && setPageFunction(i); } })));
        }
        if (currentPage + 1 < totalPages - 2) {
            items.push(React.createElement(Dots, { key: "eDot" }));
        }
        for (let i = totalPages - 1; i <= totalPages; i++) {
            items.push(React.createElement("li", { key: `e${i}` },
                React.createElement(Button, { active: false, page: i, onClick: () => { setPageFunction(i); } })));
        }
    }
    return (React.createElement("div", { className: `d:flex jc:center ${styles.wrapper}` },
        React.createElement("button", { className: styleButton, disabled: currentPage < 2, onClick: () => { setPageFunction(currentPage - 1); } },
            React.createElement("s-svg", { "data-icon": "#icon--arrow-slider-left" })),
        React.createElement("ul", { className: `d:flex list:none ${styles.items}` }, items),
        React.createElement("button", { className: styleButton, disabled: currentPage >= totalPages, onClick: () => { setPageFunction(currentPage + 1); } },
            React.createElement("s-svg", { "data-icon": "#icon--arrow-slider-right" }))));
};
